import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'react-fa';

import { AddButton as AppAddButton } from './styles';

const AddButton = ({
  title,
  onClick,
  icon,
  disabled,
  noIcon,
  type,
  button,
  noTitle,
  classes,
  backgroundType,
}) => {
  return (
    <AppAddButton backgroundType={backgroundType} type={type}
      style={{
        borderRadius:'70px',
        fontFamily: 'Public Sans',
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '24px',
        letterSpacing: '0em',
        height:'40px',
        textAlign: 'center'
      }}
      className={`btn mb-3 ml-3 ${classes}`} onClick={onClick} disabled={disabled}>
      { noIcon ? <></> : <></>} {noTitle ? 'Etapa anterior' : title}
    </AppAddButton>
  );
}

export default AddButton